import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ToastHost from './components/ToastHost';
import { installAxiosToast } from './toast';
import './App.css';
import LangToggle from './components/LangToggle';

// Editor UGC layar penuh (2026-10-08), dimuat hanya saat dibuka supaya dashboard tetap ringan.
const UgcEditor = lazy(() => import('./pages/UgcEditor'));

installAxiosToast();

function PrivateRoute({ children }) {
  const { token, loading } = useAuth();
  if (loading) return <div className="loading"><div className="spinner"/></div>;
  return token ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const { token } = useAuth();
  return token ? <Navigate to="/dashboard" /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <ToastHost />
      {/* Tombol bahasa ID ⇄ EN di semua halaman (2026-10-24, App Review Meta) */}
      <LangToggle floating />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/ugc/editor/:id" element={<PrivateRoute><Suspense fallback={<div style={{ padding: 40 }}>Memuat editor...</div>}><UgcEditor /></Suspense></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
